var render = function render() {
  var _vm$author, _vm$guide;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "microFeedTitle",
    staticClass: "micro-title",
    class: {
      'first-one': _vm.index === 0,
      'screen-optimization': _vm.isScreenOptimization
    }
  }, [_c('div', {
    ref: "titleDom",
    staticClass: "title-left",
    on: {
      "click": _vm.goHomePage
    }
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    staticClass: "img-style",
    attrs: {
      "src": _vm.avator,
      "onerror": "javascript:this.src='https://himg.bdimg.com/sys/portrait/item/f35c103e?r=1566888856';"
    }
  }), _vm.isQwzh ? _c('div', {
    staticClass: "vicon",
    style: {
      backgroundImage: `url(${_vm.vIconLogo})`
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "left-text"
  }, [_c('div', {
    staticClass: "nick-name",
    class: {
      'nick-name-content': !_vm.showMoreTag
    }
  }, [_vm._v(_vm._s(_vm.nickName))]), _vm.showMoreTag ? _c('div', {
    staticClass: "date"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": (_vm$author = _vm.author) === null || _vm$author === void 0 || (_vm$author = _vm$author.provider) === null || _vm$author === void 0 ? void 0 : _vm$author.icon
    }
  }), _c('div', {
    staticClass: "date-text"
  }, [_vm._v(" " + _vm._s(((_vm$guide = _vm.guide) === null || _vm$guide === void 0 ? void 0 : _vm$guide.message) || '查看更多'))]), !_vm.isScreenOptimization ? _c('div', {
    staticClass: "arrow-icon"
  }) : _vm._e()]) : _vm.author.date && !_vm.isScreenOptimization ? _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.author.date))]) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };